class City {
  /**
   * @param {Object} data
   * @param {number} data.id
   * @param {string} data.name
   * @param {string} data.clarifiedName
   * @param {Region} data.region
   * @param {Country} data.country
   * @param {GeoPoint} data.geoPoint
   * @param {boolean} data.isRegionalCenter
   * @param {CityType} data.cityType
   * @param {number} data.size
   */
  constructor({id, name, clarifiedName, region, country, geoPoint, isRegionalCenter, cityType, size}) {
    /** @type {number} */
    this.id = id;
    /** @type {string} */
    this.name = name;
    /** @type {string} */
    this.clarifiedName = clarifiedName;
    /** @type {Region} */
    this.region = region;
    /** @type {Country} */
    this.country = country;
    /** @type {GeoPoint} */
    this.geoPoint = geoPoint;
    /** @type {boolean} */
    this.isRegionalCenter = isRegionalCenter;
    /** @type {CityType} */
    this.cityType = cityType;
    /** @type {number} */
    this.size = size;
  }
}

export default City;